import React from 'react';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function MasterAgentDetails({ masterAgent }) {
    const { id, name, email, country, state, reseller_percent_revenue } = masterAgent;

    return (
        <Card title="Master Agent details">
            <TableDetailsBody>
                <Row label="ID">{id}</Row>
                <Row label="Name">{name}</Row>
                <Row label="Email">{email}</Row>
                <Row label="Country">{country}</Row>
                <Row label="State">{state}</Row>
                <Row label="Master Agent Percent Revenue">{reseller_percent_revenue ?? 0}%</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default MasterAgentDetails;
